import { render, staticRenderFns } from "./ReportedCase.vue?vue&type=template&id=e54d336a"
import script from "./ReportedCase.vue?vue&type=script&lang=js"
export * from "./ReportedCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports